import React, { Component } from "react";
import "./Navbar.css";

import _ from "lodash/fp";
import AddForm from "../add_form/AddForm.js";

let searchByHlpr = "";

//for IE
let s = String;
s.prototype.includes = function(str) {
	let returnValue = false;

	if (this.indexOf(str) !== -1) {
		returnValue = true;
	}

	return returnValue;
};

class Navbar extends Component {
	constructor() {
		super();
		this.state = {
			searchBy: "\u25BE",
			showAddForm: false,
			chooseInput: 0,
			showSearchList: false
		};
	}

	toggleAddForm = () => {
		this.setState({
			showAddForm: !this.state.showAddForm
		});
	};

	toggleInput = () => {
		this.setState({
			chooseInput: !this.state.chooseInput
		});
	};

	changeSearching = item => {
		this.props.filterPeople(this.props.people);
		searchByHlpr = item;
		if (searchByHlpr === "gender") {
			this.setState({
				chooseInput: 1
			});
		} else {
			this.setState({
				chooseInput: -1
			});
		}
		this.setState({
			searchBy: item
		});
		this.showSearchList();
	};

	filterUsers = e => {
		const text = e.currentTarget.value;
		if (searchByHlpr === "name") {
			const filteredUsers = this.getFilteredUsersBy(searchByHlpr, text);
			this.props.filterPeople(filteredUsers);
		} else if (searchByHlpr === "surname") {
			const filteredUsers = this.getFilteredUsersBy(searchByHlpr, text);
			this.props.filterPeople(filteredUsers);
		} else if (searchByHlpr === "address") {
			const filteredUsers = this.getFilteredUsersBy(searchByHlpr, text);
			this.props.filterPeople(filteredUsers);
		} else if (searchByHlpr === "gender") {
			const filteredUsers = this.getFilteredUsersByGender(text);
			this.props.filterPeople(filteredUsers);
		}
	};

	getFilteredUsersBy = (value, text) => {
		return this.props.people.filter(person =>
			person[value].toLowerCase().includes(text.toLowerCase())
		);
	};

	getFilteredUsersByGender = text => {
		if (text === "-") {
			return this.props.people;
		} else {
			return this.props.people.filter(
				person => person.gender.toLowerCase() === text.toLowerCase()
			);
		}
	};

	showSearchList = () => {
		if (this.state.showSearchList) {
			this.setState({
				showSearchList: false
			});
		} else {
			this.setState({
				showSearchList: true
			});
		}
	};

	render() {
		const items = this.props.items;
		const listItems = _.map(
			item => (
				<li key={item} onClick={() => this.changeSearching(item)}>
					- {item}
				</li>
			),
			items
		);

		return (
			<div className="Navbar">
				<div className="Desktop-navbar">
					<div className="Nav-buttons-left-side">
						<div
							className="Nav-button Add-person-button"
							onClick={this.toggleAddForm.bind(this)}
						>
							<div className="Nav-button-icon">
								<i className="far fa-address-card" />
							</div>
							<div className="Nav-button-text">Add person</div>
						</div>

						<div className="Search-dropdown-wrapper">
							<div
								className="Nav-button Search-by-button"
								onClick={this.showSearchList.bind(this)}
							>
								<div className="Nav-button-icon">
									<i className="fas fa-search" />
								</div>
								<div className="Nav-button-text">
									<span>
										{"Search by " + this.state.searchBy}
									</span>
								</div>
							</div>

							<div className="Nav-list-wrapper">
								{this.state.showSearchList ? (
									<ul className="Nav-list">{listItems}</ul>
								) : null}
							</div>
						</div>
						{this.state.chooseInput !== 0 ? (
							this.state.chooseInput === -1 ? (
								<div className="Input-options">
									<input
										className="Search-input"
										placeholder={
											"Type " +
											this.state.searchBy +
											"..."
										}
										onInput={this.filterUsers.bind(this)}
									/>
								</div>
							) : (
								<div className="Input-options">
									<select
										className="Search-select"
										onChange={this.filterUsers.bind(this)}
									>
										<option value="-">Select...</option>
										<option value="male">Male</option>
										<option value="female">Female</option>
									</select>
								</div>
							)
						) : null}
					</div>

					<div className="Nav-buttons-right-side">
						{this.props.people.length !== 0 ? (
							<div
								className="Nav-button Delete-all-button"
								onClick={this.props.deleteAll}
							>
								<div className="Nav-button-icon">
									<i className="far fa-trash-alt" />
								</div>
								<div className="Nav-button-text">
									Delete all
								</div>
							</div>
						) : null}
					</div>
					{this.state.showAddForm ? (
						<AddForm
							toEdit={false}
							closeAddForm={this.toggleAddForm.bind(this)}
							people={this.props.people}
							addPeople={this.props.addPeople}
						/>
					) : null}
				</div>

				<div className="Mobile-navbar">
					<div
						className="Nav-button Add-person-button"
						onClick={this.toggleAddForm.bind(this)}
					>
						<div className="Nav-button-icon">
							<i className="far fa-address-card" />
						</div>
						<div className="Nav-button-text">Add person</div>
					</div>

					<div className="Search-dropdown-wrapper">
						<div
							className="Nav-button Search-by-button"
							onClick={this.showSearchList.bind(this)}
						>
							<div className="Nav-button-icon">
								<i className="fas fa-search" />
							</div>
							<div className="Nav-button-text">
								<span>
									{"Search by " + this.state.searchBy}
								</span>
							</div>
						</div>

						<div className="Nav-list-wrapper">
							{this.state.showSearchList ? (
								<ul className="Nav-list">{listItems}</ul>
							) : null}
						</div>
					</div>
					{this.state.chooseInput !== 0 ? (
						this.state.chooseInput === -1 ? (
							<input
								className="Search-input"
								placeholder={
									"Type " + this.state.searchBy + "..."
								}
								onInput={this.filterUsers.bind(this)}
							/>
						) : (
							<select
								className="Search-select"
								onChange={this.filterUsers.bind(this)}
							>
								<option value="-">Select...</option>
								<option value="male">Male</option>
								<option value="female">Female</option>
							</select>
						)
					) : null}

					{this.props.people.length !== 0 ? (
						<div
							className="Nav-button Delete-all-button"
							onClick={this.props.deleteAll}
						>
							<div className="Nav-button-icon">
								<i className="far fa-trash-alt" />
							</div>
							<div className="Nav-button-text">Delete all</div>
						</div>
					) : null}
				</div>
				{this.state.showAddForm ? (
					<AddForm
						toEdit={false}
						closeAddForm={this.toggleAddForm.bind(this)}
						people={this.props.people}
						addPeople={this.props.addPeople}
					/>
				) : null}
			</div>
		);
	}
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/navbar/Navbar.js